// import './SelectStores.less';

export const prefix = 'bm-c-select-stores';

export { default } from './SelectStores';
